import { BHG_OFFERING_ID } from "./constants";

export const BHG_ROUTES = {
  PRODUCT: `products/${BHG_OFFERING_ID}`,
  SIGNUP: `products/${BHG_OFFERING_ID}/signup`,
  DEMO: `products/${BHG_OFFERING_ID}/demo`,
  DASHBOARD: `dashboard/${BHG_OFFERING_ID}`,
} as const;
